import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Checkbox,
} from '@mui/material';
import { preferredColumns } from '../features_utils';

const ColumnSettingsDialog = ({
  open,
  onClose,
  allColumns,
  visibleColumns,
  onColumnToggle,
  onColumnsChange,
}) => {

  const handleSelectDefaults = () => {
    const filteredDefaults = preferredColumns.filter((col) => allColumns.includes(col));
    onColumnsChange(filteredDefaults);
  };

  const handleSelectTags = () => {
    const tagColumns = allColumns.filter((column) => column.startsWith('TAG:'));
    const filteredDefaults = preferredColumns.filter((col) => allColumns.includes(col));
    const newVisible = Array.from(new Set([...filteredDefaults, ...tagColumns]));
    onColumnsChange(newVisible);
  };

  const handleSelectAILabels = () => {
    const aiColumns = allColumns.filter((column) => column.startsWith('AI:'));
    const filteredDefaults = preferredColumns.filter((col) => allColumns.includes(col));
    const newVisible = Array.from(new Set([...filteredDefaults, ...aiColumns]));
    onColumnsChange(newVisible);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth autoFocus>
      <DialogTitle>Column Settings</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TableContainer>
            <Table>
              <TableBody>
                {allColumns.map((column) => (
                  <TableRow key={column}>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Checkbox
                          checked={visibleColumns.includes(column)}
                          onChange={() => onColumnToggle(column)}
                        />
                        {column}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSelectDefaults} variant="outlined">
          Select Defaults
        </Button>
        <Button onClick={handleSelectTags} variant="outlined">
          Select All Tags
        </Button>
        <Button onClick={handleSelectAILabels} variant="outlined">
          Select All AI Labels
        </Button>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColumnSettingsDialog;

